// Matches PROGRESS in the API's tutorReplacementTracker.controller.js
export const PROGRESS = { PENDING: 0, RETAINED: 1, TUTOR_CHANGE: 2 };

export const PROGRESS_LABEL = {
  [PROGRESS.PENDING]: 'Pending',
  [PROGRESS.RETAINED]: 'Retained',
  [PROGRESS.TUTOR_CHANGE]: 'Tutor change',
};

export const PROGRESS_COLOR = {
  [PROGRESS.PENDING]: { color: '#92400E', bg: '#FEF3C7' },
  [PROGRESS.RETAINED]: { color: '#065F46', bg: '#D1FAE5' },
  [PROGRESS.TUTOR_CHANGE]: { color: '#1E40AF', bg: '#DBEAFE' },
};

// options for the progress dialog
export const PROGRESS_OPTIONS = [
  { id: PROGRESS.RETAINED, name: PROGRESS_LABEL[PROGRESS.RETAINED] },
  { id: PROGRESS.TUTOR_CHANGE, name: PROGRESS_LABEL[PROGRESS.TUTOR_CHANGE] },
];

// filter dropdowns; `id` is the API query value
export const TUTOR_STATUS_FILTERS = [
  { id: 'all', name: 'All' },
  { id: 'awaiting', name: 'Awaiting new tutor' },
  { id: 'assigned', name: 'New tutor assigned' },
];

export const PROGRESS_FILTERS = [
  { id: 'all', name: 'All' },
  { id: 'pending', name: 'Pending' },
  { id: 'retained', name: 'Retained' },
  { id: 'tutor_change', name: 'Tutor change' },
];

// TA head page only: whether the row has been handed to someone in the team
export const ASSIGNMENT_FILTERS = [
  { id: 'all', name: 'All' },
  { id: 'assigned', name: 'Assigned' },
  { id: 'unassigned', name: 'Not assigned' },
];

// `view` query value of GET /tutor-replacement-tracker, one page each
export const VIEWS = {
  HEAD: 'head', // TA wing head of the course's project: assigns to the team
  MINE: 'mine', // TA associate: updates progress on rows assigned to them
  CRO: 'cro', // CRO: their own students' replacements, read-only
};

export const VIEW_PATHS = {
  [VIEWS.HEAD]: '/my-workspace/tutor-replacement-ta-head',
  [VIEWS.MINE]: '/my-workspace/tutor-replacement-ta-associate',
  [VIEWS.CRO]: '/my-workspace/tutor-replacement-cro',
};

// `key` is the matching field in meta.summary
export const CARD = {
  total: { key: 'total', title: 'Total Inactivated', icon: 'mdi:account-off-outline', color: { from: '#4F46E5', to: '#7C3AED' } },
  unassigned: { key: 'unassigned', title: 'Not Assigned', icon: 'mdi:account-question-outline', color: { from: '#EA580C', to: '#F59E0B' } },
  awaitingTutor: { key: 'awaitingTutor', title: 'Awaiting New Tutor', icon: 'mdi:account-clock-outline', color: { from: '#DC2626', to: '#F43F5E' } },
  newTutorAssigned: { key: 'newTutorAssigned', title: 'New Tutor Assigned', icon: 'mdi:account-check-outline', color: { from: '#059669', to: '#10B981' } },
  pending: { key: 'pending', title: 'Progress Pending', icon: 'mdi:progress-clock', color: { from: '#B45309', to: '#D97706' } },
  retained: { key: 'retained', title: 'Retained', icon: 'mdi:account-heart-outline', color: { from: '#0F766E', to: '#14B8A6' } },
  tutorChange: { key: 'tutorChange', title: 'Tutor Change', icon: 'mdi:account-switch-outline', color: { from: '#0284C7', to: '#06B6D4' } },
};
